export default "__VITE_ASSET__25cab559__"